import { render } from "./SubobjectView.vue?vue&type=template&id=00381078"
import script from "./SubobjectView.vue?vue&type=script&lang=js"
export * from "./SubobjectView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__